// extracted by mini-css-extract-plugin
export default {"pageHeaderCon":"styles_pageHeaderCon__2uHes","profileTab":"styles_profileTab__mFSiT"};